<script lang="ts" setup>
import { ElLoading } from 'element-plus'
const props = withDefaults(defineProps<{
  loading?: boolean,
  title: string,
  normalBut?: boolean,
}>(), {
  loading: false,
  title: '新建',
  normalBut: true,
})
const emits = defineEmits(['cancel', 'confirm'])

function handleClose(done: () => void) {
  handleCancel()
  done()
}

function handleCancel() {
  emits('cancel')
}

function handleConfirm() {
  emits('confirm')
}
let loadingInstance: any = null
watch(() => props.loading, (newValue) => {
  if (newValue) {
    loadingInstance = ElLoading.service({ fullscreen: false, target: '.jy-drawer' })
  } else {
    nextTick(() => {
      loadingInstance && loadingInstance.close()
    })
  }
})
</script>

<template>
  <el-drawer :model-value="true" :title="title" size="830px" :before-close="handleClose" class="jy-drawer">
    <template #default>
      <slot name="default" />
    </template>
    <template #footer>
      <template v-if="$slots.footer">
        <slot name="footer" />
      </template>
      <template v-else>
        <template v-if="normalBut">
          <el-button @click="handleCancel">
            取消
          </el-button>
          <el-button type="primary" @click="handleConfirm">
            确定
          </el-button>
        </template>
        <template v-else>
          <el-button @click="handleCancel">
            关闭
          </el-button>
        </template>
      </template>
    </template>
  </el-drawer>
</template>

<style lang="scss">
.jy-drawer {
  .el-drawer__close-btn {

    &:focus,
    &:hover {
      i {
        color: $color--white;
      }
    }
  }

  .el-input, .el-cascader,
  .el-select {
    width: 100%;
  }
}
</style>
